<template>
  <div class="book-card" @click="$emit('click', book)">
    <div class="book-cover">
      <img v-if="book.cover" :src="book.cover" :alt="book.title" />
      <img v-else src="@/assets/images/no-img.png" alt="no image" />
    </div>
    <div class="book-meta">
      <div class="title-container">
        <div class="book-title-zh" :title="book.title">{{ book.title }}</div>
        <div v-if="book.titleEn" class="book-title-en" :title="book.titleEn">
          {{ book.titleEn }}
        </div>
      </div>
      <div class="meta-footer">
        <div v-if="book.author" class="book-author" :title="book.author">{{ book.author }}</div>
        <div v-if="book.date" class="book-date">{{ book.date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookCard",
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.book-card {
  width: 200px;
  height: 430px;
  padding: 15px 12px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #dadada;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    
    .book-title-zh {
      color: $title-color;
    }
    .book-title-en {
      color: $title-color;
    }
  }
}

.book-cover {
  width: 100%;
  height: 260px;
  aspect-ratio: 3 / 4;
  margin-bottom: 10px;
  position: relative;

  img {
    bottom: 0;
    display: block;
    height: auto;
    left: 0;
    margin: auto;
    max-width: 100%;
    position: absolute;
    right: 0;
  }
}

.book-meta {
  flex: 1;
  display: flex;
  flex-direction: column;
  
  .title-container {
    margin-bottom: 8px;
  }
  
  .book-title-zh {
    font-size: 16px;
    color: $text-dark;
    line-height: 1.2;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .book-title-en {
    font-size: 16px;
    color: $text-dark;
    font-style: italic;
    line-height: 1;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .meta-footer {
    margin-top: auto;
  }

  .book-author {
    font-size: 16px;
    color: $text-gray;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .book-date {
    font-size: 16px;
    color: $text-gray;
  }
  
}
</style>